export default "__VITE_ASSET__D3Z1JL5Z__"